import Icon, { icons } from './Icon'
import FA from './FA'
export default Icon; 
export { Icon, icons, FA };